export default {
    template: '#side_switch_control',
    props: ['product'],
    methods: {
        changeDesignSide: function () {
            if (this.$root.currentSide == 'front') {
                this.$root.$set('currentSide', 'back');
            } else {
                this.$root.$set('currentSide', 'front');
            }
            this.$dispatch('on-side-changed', this.$root.currentSide);
        },
        getCurrentSide: function () {
            return this.$root.currentSide;
        },
        getBackText: function () {
            if (this.product) {
                return this.product.product.back_thumbnail_text.toString().replace(/\w\S*/g, function(txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            } else {
                return "Back";
            }
        }
    },
    computed: {
        showControl: function () {
            if (this.product) {

                if(this.product.product.back_thumbnail_text == '') {
                    return false;
                }

                return this.product.product.back_view == "SHOW";
            }
        }
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/controls/sideSwitcher.js